import { WebhookUrlList } from './WebhookUrlList'

export default WebhookUrlList
